import { WorkflowStepsBaseService } from "app/core/workflow/workflow-steps/workflow-steps-base.service";
import { AdditionalOptionsComponentPath } from "app/core/workflow/page-path/statement-page-path/additional-options-component.path";

export class WorkflowAdditionalOptionsService extends WorkflowStepsBaseService {
  public get isDone(): boolean {
    return !!this.statement && !!this.statement.stageSteuerAdditionalOption;
  }

  public get isRequired(): boolean {
    return !this.isBusiness || this.isTaxAdviser;
  }

  public get isVisible(): boolean {
    return this.isRequired;
  }

  public get title(): string {
    return "ASIDE_BAR.STEUER_INCOME_DEDUCTION";
  }

  public get isFakeStep(): boolean {
    return false;
  }

  public get checkCanGo(): boolean {
    return !this.blockedDefaultWorkflow
      && this.statement
      && this.isRequired
      && !!this.statement.stageAdditionalIncome;
  }

  public get isActiveOnStepsBar(): boolean {
    return window.location.href.search(AdditionalOptionsComponentPath.regex()) !== -1;
  }

  public get isActive(): boolean {
    return this.defaultIsActiveFunction;
  }

  public get stepClass(): string {
    return this.classHasSubs;
  }

  public get urlRegex(): RegExp {
    return AdditionalOptionsComponentPath.regex(1);
  }

  public get url(): string {
    return AdditionalOptionsComponentPath.url(this.statement && this.statement.id ? this.statement.id : 0, 1);
  }
}
